module.exports = "<i class=flag ng-class=country|lowercase></i> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/common/directives/flag/flag.html
// module id = 267
// module chunks = 0